import { ReactNode } from 'react'
import { Paragraph } from '@sbab-ui/components'

interface Props {
  children: ReactNode
  value: string
  ['data-cy']?: string
  greenMortgage?: boolean
  blur: boolean
}

function TableRow({ children, value, 'data-cy': dataCy, greenMortgage, blur }: Readonly<Props>) {
  return (
    <div
      className="flex"
      data-cy={dataCy}
      style={{ borderBottom: `1px solid ${blur ? '#F2F2F2' : '#D9D9D9'}` }}
    >
      <div className="flex flex-1 items-center bg-neutral-95 p-4">{children}</div>
      <div className="flex flex-1 items-center justify-end  p-4">
        <Paragraph className={`!mt-0 ${greenMortgage && 'text-semantic-success'}`}>
          {value}
        </Paragraph>
      </div>
    </div>
  )
}

export default TableRow
